import React, { useState, useEffect } from "react";
import ShimmerLoader from "../../components/ShimmerLoader";
import { useDispatch, useSelector } from "react-redux";
import { fetchGroupRequest, fetchBookingDetails, GroupRequestUpdate } from "../flight/flightSlice";
import { MakePayments } from "../wallet/walletSlice";
import { selectCurrentUser } from "../auth/authSlice";
import Moment from "moment";
import { format, parseISO } from "date-fns";
import { Funnel } from "lucide-react";
import { ChevronDown, ChevronUp, Ellipsis, X } from "lucide-react";
import CurFt from "../../components/CurFt";
import CursorPagination from "../../components/CursorPagination";
import useDocumentTitle from "../../hooks/useDocumentTitle";
import { Dialog } from "@headlessui/react";
import { toast } from 'react-hot-toast';
import WalletUtils from "../../utils/walletUtils";
import { usePaymentProcessRecharge } from "../../services/usePaymentProcessRecharge";
import { encryptAES } from "../../utils/crypto";
import { getapiKey } from "../../api/axios";

export default function GroupRequest() {
  useDocumentTitle("Group Request");
  const dispatch = useDispatch();
  const { bookingcalendarStatus, bookingcalendar } = useSelector((state) => state.flights);
  const perPage = 25;
  const [nextCursor, setNextCursor] = useState(null);
  const [prevCursor, setPrevCursor] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [BOOKINGSTATUS, SetBOOKINGSTATUS] = useState({});
  const [PAYMENTSTATUS, SetPAYMENTSTATUS] = useState({});
  const [BookingHistory, SetBookingHistory] = useState([]);
  const user = useSelector(selectCurrentUser);
  const [showFilters, setShowFilters] = useState(false);
  const [FilterData, setFilterData] = useState({
    filterType: "Flight",
    bookingID: "",
    PNRNumber: "",
    BookingStatus: [20, 31, 32, 33, 34],
    supplierType: "All",
    JourneyType: "All",
    Type: "All",
    FirstName: "",
    FromDate: null,
    ToDate: null,
    TravelFromDate: null,
    TravelToDate: null,
    validate: true,
  });
  const fetchBookingHistory = async (cursor = null) => {
    dispatch(fetchGroupRequest({ FilterData, perPage, cursor }));
  };
  useEffect(() => {
    fetchBookingHistory();
  }, [FilterData]);

  useEffect(() => {
    const data = bookingcalendar?.Booking;
    SetBookingHistory(data?.data || []);
    SetBOOKINGSTATUS(bookingcalendar?.BOOKINGSTATUS || {});
    SetPAYMENTSTATUS(bookingcalendar?.PAYMENTSTATUS || {});
    setNextCursor(data?.next_cursor);
    setPrevCursor(data?.prev_cursor);
  }, [bookingcalendarStatus, bookingcalendar]);

  const handleNextPage = () => {
    if (nextCursor) {
      fetchBookingHistory(nextCursor);
    }
  };

  const handlePrevPage = () => {
    if (prevCursor) {
      fetchBookingHistory(prevCursor);
    }
  };
  const toggleFilters = () => {
    setShowFilters(!showFilters);
  };

  const handleFilterChange = (field, value) => {
    setFilterData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };
  useEffect(() => {
    const close = () => setOpenRowId(null);
    document.addEventListener("click", close);
    return () => document.removeEventListener("click", close);
  }, []);
  const [openRowId, setOpenRowId] = useState(null);
  const [loading, setloading] = useState(false);
  const [isSectorModalOpen, setIsModalSector] = useState(false);
  const [BookingData, setBookingData] = useState([]);
  const [loadingData, setloadingData] = useState(true);
  const [Currency, setCurrency] = useState("");
  const [SelectedItem, setSelectedItem] = useState({});
  const [PaymentAmount, setPaymentAmount] = useState(0);
  const [fare, setfare] = useState([]);
  const [open, setOpen] = useState(false);
  const [formData, setFormData] = useState({
    remarks: "",
  });

  const fetchBooking = async (BookingID) => {
    try {
      const response = await dispatch(
        fetchBookingDetails({ BookingID })
      ).unwrap();
      if (response.data.status.success) {
        setfare(response.data.data.fare)
        setBookingData(response.data.data.BookingDetails)
        setCurrency(response.data.data.BookingDetails[0].Currncy)
        setloadingData(false)
      } else {
        toast.error(response.data.message, { autoClose: 2000 });
        setloadingData(false)
      }
    } catch (error) {
      toast.error('We regret to inform you that your booking could not be completed due to an internal issue.', { autoClose: 2000 });
      console.error("Error:", error);
      setloadingData(false)
    }
  };
  const MakePayment = async (item) => {
    setOpen(true)
    setSelectedItem(item);
    let BookingID = item.BookingID
    fetchBooking(BookingID);
    let CalculateAmount = 0;
    if (item?.partialpayment && item?.PaymentStatus === 0) {
      let payment_percentage = parseFloat(item?.payment_percentage);
      CalculateAmount = ((item?.PubFare * payment_percentage) / 100)
    } else if (item?.partialpayment && item?.PaymentStatus === 2) {
      let payment_percentage = parseFloat(item?.payment_percentage);
      let used = ((item?.PubFare * payment_percentage) / 100)
      CalculateAmount = item?.PubFare - used;
    } else {
      CalculateAmount = item?.PubFare;
    }
    setPaymentAmount(CalculateAmount)

  }
  const CheckQuoteHand = async (item) => {
    let BookingID = item.BookingID
    let CalculateAmount = 0;
    if (item?.partialpayment) {
      let payment_percentage = parseFloat(item?.payment_percentage);
      CalculateAmount = ((item?.PubFare * payment_percentage) / 100)
    } else {
      CalculateAmount = item?.PubFare;
    }
    setPaymentAmount(CalculateAmount)
    setSelectedItem(item);
    setIsModalSector(true);
    setloadingData(true)
    try {
      const response = await dispatch(
        fetchBookingDetails({ BookingID })
      ).unwrap();
      if (response.data.status.success) {
        setfare(response.data.data.fare)
        setBookingData(response.data.data.BookingDetails)
        setCurrency(response.data.data.BookingDetails[0].Currncy)
        setloadingData(false)
      } else {
        toast.error(response.data.message, { autoClose: 2000 });
        setloadingData(false)
      }
    } catch (error) {
      toast.error('We regret to inform you that your booking could not be completed due to an internal issue.', { autoClose: 2000 });
      console.error("Error:", error);
      setloadingData(false)
    }
  };
  useEffect(() => {
    let CalculateAmount = 0;
    if (SelectedItem?.partialpayment && SelectedItem?.PaymentStatus === 0) {
      let payment_percentage = parseFloat(SelectedItem?.payment_percentage);
      CalculateAmount = ((parseFloat(fare?.TotalGrand) * payment_percentage) / 100)
    } else if (SelectedItem?.partialpayment && SelectedItem?.PaymentStatus === 2) {
      let payment_percentage = parseFloat(SelectedItem?.payment_percentage);
      let used = ((parseFloat(fare?.TotalGrand) * payment_percentage) / 100)
      CalculateAmount = parseFloat(fare?.TotalGrand) - used;
    } else {
      CalculateAmount = fare?.TotalGrand || 0;
    }
    setPaymentAmount(CalculateAmount)
  }, [fare]);
  const handleChange = (eOrName: any, value?: any) => {
    if (typeof eOrName === "string") {
      // Case: custom components like DateInput
      setFormData((prev) => ({
        ...prev,
        [eOrName]: value,
      }));
    } else {
      // Case: normal <input />, <select />, etc.
      const e = eOrName;
      setFormData((prev) => ({
        ...prev,
        [e.target.name]: e.target.value,
      }));
    }
  };
  const [errorMessageRecharge, SetErrorMessageRecharge] = useState("loading");
  const [paymentHookStatusRecharge, setpaymentHookStatusRecharge] = useState(null);
  const [ResponseData, SetResponseData] = useState(null);
  const { handleProceedRecharge } = usePaymentProcessRecharge({
    SetErrorMessageRecharge: SetErrorMessageRecharge,
    setpaymentHookStatusRecharge: setpaymentHookStatusRecharge,
    SetResponseData: SetResponseData,
  });
  const handleSubmit = async (e) => {
    e.preventDefault();
    let savetype = e.nativeEvent.submitter.attributes.savetype.value
    if (formData.remarks === '') {
      toast.error('Please enter remarks!', { autoClose: 2000 });
      return false;
    }
    const postData = {
      BookingID: SelectedItem?.BookingID,
      Remarks: formData.remarks,
      action: savetype,
    }
    setloading(true);

    try {
      const response = await dispatch(
        GroupRequestUpdate({ postData })
      ).unwrap();
      if (response.data.status.success) {
        toast.success(response.data.message, { autoClose: 3000 });
        fetchBookingHistory();
        setIsModalSector(false);
        setFormData((prev) => ({
          ...prev,
          ['remarks']: '',
        }));
        setloading(false);
        if (savetype === '2') {
          setOpen(true)
        }

      } else {
        toast.error(response.data.message, { autoClose: 2000 });
        setloading(false);
      }
    } catch (error) {
      toast.error('We regret to inform you that your request could not be completed due to an internal issue.', { autoClose: 2000 });
      console.error("Error:", error);
      setloading(false);
    }
  };

  useEffect(() => {
    setTimeout(() => {
      if (paymentHookStatusRecharge === "success") {
        setloading(false);
        setOpen(false)
        fetchBookingHistory();
        toast.success("Payment successful", { autoClose: 4000 });
      } else if (paymentHookStatusRecharge === "paymentfailed") {
        setloading(false);
        SetErrorMessageRecharge("paymentfailed");
        toast.error("Payment failed. plese contact with support team.", { autoClose: 4000 });
      }
    }, 3000);
  }, [paymentHookStatusRecharge, errorMessageRecharge]);

  const [paymentMode, SetpaymentMode] = useState("1");
  const paymentModeHandle = (event) => {
    const { value, checked } = event.target;
    SetpaymentMode(value)
  }
  const [PaymentProcessloading, setPaymentProLoading] = useState(false)

  const handleSubmitPayment = async (e) => {
    e.preventDefault();
    let remark = e.target.remark.value;
    if (remark === '') {
      toast.error('Enter your remarks', { autoClose: 2000 });
      return false;
    }
    const postData = {
      RefrenceNo: SelectedItem?.BookingID,
      Remark: remark,
      PlanType: 1,
      customer_id: user?.UserData?.user?.id,
      amount: parseFloat(PaymentAmount).toFixed(2)
    }
    setPaymentProLoading(true);
    let txnid = "TXN" + Date.now();
    const hash = WalletUtils.walletCode(
      txnid,
      txnid,
      parseFloat(PaymentAmount).toFixed(2),
      user?.UserData?.name,
      user?.UserData?.mobile,
      user?.UserData?.email,
      "Group Request Payment"
    );
    let encrypt = encryptAES(JSON.stringify(postData), getapiKey(), getapiKey())
    const customerInfo = {
      txnid: txnid,
      amount: parseFloat(PaymentAmount).toFixed(2),
      name: user?.UserData?.name,
      email: user?.UserData?.email,
      phone: user?.UserData?.mobile,
      productinfo: "Group Request Payment",
      surl: "https://ozilconnect.com/payment/payment-success",
      furl: "https://ozilconnect.com/payment/payment-success",
      udf1: SelectedItem?.BookingID,
      udf2: "5",
      udf3: "Web-B2B",
      udf4: user?.UserData?.user?.id, // customer id
      udf5: user?.UserData?.user?.AgencyID,
      udf6: "INR",
      udf7: encrypt,
      udf8: "",
      udf9: "",
      udf10: "",
      securecode: hash,
    };

    if (paymentMode === '2') {
      handleProceedRecharge(customerInfo);
    } else {
      try {
        const response = await dispatch(
          MakePayments({ postData })
        ).unwrap();
        if (response.data.status.success) {
          fetchBookingHistory();
          setOpen(false)
          toast.success(response.data.message, { autoClose: 6000 });
        } else {
          toast.error(response.data.message, { autoClose: 2000 });
          setPaymentProLoading(false);
        }
      } catch (error) {
        toast.error('We regret to inform you that your payment could not be completed due to an internal issue.', { autoClose: 2000 });
        console.error("Error:", error);
        setPaymentProLoading(false);
      }
    }

  }
  return (
    <div className="bg-gray-100 text-gray-800 relative min-h-screen">
      {/* Main Content */}
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-4 space-y-6">
        <div className="bg-white shadow-md rounded-lg p-4 mt-4">
          {/* Header */}
          <div className="flex items-center justify-between">
            <h3 className="font-semibold">Group Request</h3>
            <span className="font-semibold text-blue-500 flex items-center gap-1">
              <div className="relative inline-block text-left">
                <button
                  onClick={toggleFilters}
                  className={`px-5 py-2 rounded font-medium shadow transition flex items-center gap-2 ${showFilters ? "bg-blue-600 text-white" : "bg-blue-500 hover:bg-blue-600 text-white"
                    }`}
                >
                  <Funnel size={18} />
                  Filters
                </button>
              </div>
            </span>
          </div>
        </div>
        {showFilters && (
          <div className="bg-white shadow-md rounded-lg p-6 mt-4">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4">
              {/* First Row */}
              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-medium mb-2">Booking ID</label>
                  <input
                    type="text"
                    value={FilterData.bookingID}
                    onChange={(e) => handleFilterChange("bookingID", e.target.value)}
                    className="w-full border rounded-lg px-3 py-2 text-sm"
                    placeholder="Booking ID"
                  />
                </div>
              </div>

              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-medium mb-2">Journey Type</label>
                  <select
                    value={FilterData.JourneyType}
                    onChange={(e) => handleFilterChange("JourneyType", e.target.value)}
                    className="w-full border rounded-lg px-3 py-2 text-sm"
                  >
                    <option value="All">All</option>
                    <option value="0">Domestic</option>
                    <option value="1">International</option>
                  </select>
                </div>
              </div>

              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-medium mb-2">Booking From Date</label>
                  <div className="relative">
                    <input
                      type="date"
                      value={FilterData.FromDate ? new Date(FilterData.FromDate).toISOString().split("T")[0] : ""}
                      onChange={(e) => {
                        const date = e.target.value;
                        const formattedDate = date ? new Date(date + "T18:30:00.000Z").toISOString() : null;
                        handleFilterChange("FromDate", formattedDate);
                      }}
                      max={new Date().toISOString().split("T")[0]}
                      className="w-full border rounded-lg px-3 py-2 text-sm pr-10 bg-white focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    />
                    {FilterData.FromDate && (
                      <button
                        type="button"
                        onClick={() => handleFilterChange("FromDate", null)}
                        className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-red-500 transition-colors"
                      >
                        ✕
                      </button>
                    )}
                  </div>
                </div>
              </div>

              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-medium mb-2">Booking To Date</label>
                  <div className="relative">
                    <input
                      type="date"
                      value={FilterData.ToDate ? new Date(FilterData.ToDate).toISOString().split("T")[0] : ""}
                      onChange={(e) => {
                        const date = e.target.value;
                        const formattedDate = date ? new Date(date + "T18:30:00.000Z").toISOString() : null;
                        handleFilterChange("ToDate", formattedDate);
                      }}
                      className="w-full border rounded-lg px-3 py-2 text-sm pr-10 bg-white focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    />
                    {FilterData.ToDate && (
                      <button
                        type="button"
                        onClick={() => handleFilterChange("ToDate", null)}
                        className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-red-500 transition-colors"
                      >
                        ✕
                      </button>
                    )}
                  </div>
                </div>
              </div>

              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-medium mb-2">Travel From Date</label>
                  <div className="relative">
                    <input
                      type="date"
                      value={
                        FilterData.TravelFromDate ? new Date(FilterData.TravelFromDate).toISOString().split("T")[0] : ""
                      }
                      onChange={(e) => {
                        const date = e.target.value;
                        const formattedDate = date ? new Date(date + "T18:30:00.000Z").toISOString() : null;
                        handleFilterChange("TravelFromDate", formattedDate);
                      }}
                      className="w-full border rounded-lg px-3 py-2 text-sm pr-10 bg-white focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    />
                    {FilterData.TravelFromDate && (
                      <button
                        type="button"
                        onClick={() => handleFilterChange("TravelFromDate", null)}
                        className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-red-500 transition-colors"
                      >
                        ✕
                      </button>
                    )}
                  </div>
                </div>
              </div>

              {/* Second Row */}
              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-medium mb-2">Travel To Date</label>
                  <div className="relative">
                    <input
                      type="date"
                      value={
                        FilterData.TravelToDate ? new Date(FilterData.TravelToDate).toISOString().split("T")[0] : ""
                      }
                      onChange={(e) => {
                        const date = e.target.value;
                        const formattedDate = date ? new Date(date + "T18:30:00.000Z").toISOString() : null;
                        handleFilterChange("TravelToDate", formattedDate);
                      }}
                      className="w-full border rounded-lg px-3 py-2 text-sm pr-10 bg-white focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    />
                    {FilterData.TravelToDate && (
                      <button
                        type="button"
                        onClick={() => handleFilterChange("TravelToDate", null)}
                        className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-red-500 transition-colors"
                      >
                        ✕
                      </button>
                    )}
                  </div>
                </div>
              </div>

              {/* Empty columns for spacing in second row */}
              <div className="space-y-4"></div>
              <div className="space-y-4"></div>
              <div className="space-y-4"></div>

              {/* Close Button in second row */}
              <div className="space-y-4">
                <div className="pt-6">
                  <button
                    onClick={() => setShowFilters(false)}
                    className="w-full bg-gray-500 text-white px-4 py-2 rounded-lg hover:bg-gray-600 transition-colors"
                  >
                    Close Filters
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
        {open && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm">
            <div className="relative w-full max-w-[520px] rounded-2xl bg-white shadow-2xl">

              {/* Header */}
              <div className="flex items-center justify-between border-b px-6 py-4">
                <h2 className="text-lg font-semibold text-gray-800">
                  Payment Details
                </h2>

                {/* Close Icon */}
                <button
                  type="button"
                  onClick={() => setOpen(false)}
                  className="rounded-full p-1 text-gray-500 hover:bg-gray-100 hover:text-gray-700 transition"
                >
                  <X className="h-5 w-5" />
                </button>
              </div>

              {/* Body */}
              <div className="px-6 py-5">
                <form onSubmit={handleSubmitPayment} className="mui-form">
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">

                    {/* Booking ID */}
                    <div>
                      <label className="block text-xs font-medium text-gray-500">
                        Booking ID
                      </label>
                      <input
                        type="text"
                        value={SelectedItem?.BookingID}
                        readOnly
                        className="mt-1 w-full rounded-lg border border-gray-300 bg-gray-50 px-3 py-2 text-sm text-gray-700 focus:border-blue-500 focus:ring-2 focus:ring-blue-500"
                        placeholder="Booking ID"
                      />
                    </div>

                    {/* Pending Amount */}
                    <div>
                      <label className="block text-xs font-medium text-gray-500">
                        Pending Amount
                      </label>
                      <input
                        type="text"
                        value={parseFloat(PaymentAmount).toFixed(2)}
                        readOnly
                        className="mt-1 w-full rounded-lg border border-gray-300 bg-gray-50 px-3 py-2 text-sm font-semibold text-gray-800 focus:border-blue-500 focus:ring-2 focus:ring-blue-500"
                        placeholder="Pending Amount"
                      />
                    </div>

                    {/* Remark */}
                    <div className="sm:col-span-2">
                      <label className="block text-xs font-medium text-gray-500">
                        Remark
                      </label>
                      <input
                        type="text"
                        name="remark"
                        placeholder="Remark"
                        defaultValue="Group booking payment"
                        className="mt-1 w-full rounded-lg border border-gray-300 px-3 py-2 text-sm text-gray-700 focus:border-blue-500 focus:ring-2 focus:ring-blue-500"
                      />
                    </div>

                    {/* Payment Mode */}
                    <div className="sm:col-span-2">
                      <label className="block text-xs font-medium text-gray-500 mb-2">
                        Payment Mode
                      </label>

                      <ul className="flex flex-col sm:flex-row gap-4">
                        <li className="flex-1">
                          <label
                            htmlFor="FullPay"
                            className={`flex items-center gap-3 rounded-xl border px-4 py-3 cursor-pointer transition
                      ${paymentMode == 1
                                ? 'border-blue-500 bg-blue-50'
                                : 'border-gray-300 hover:border-blue-400'
                              }`}
                          >
                            <input
                              type="radio"
                              id="FullPay"
                              value="1"
                              name="paymentMode"
                              onChange={paymentModeHandle}
                              checked={paymentMode == 1}
                              className="h-4 w-4 text-blue-600 focus:ring-blue-500"
                            />
                            <span className="text-sm font-medium text-gray-700">
                              Wallet
                            </span>
                          </label>
                        </li>

                        <li className="flex-1">
                          <label
                            htmlFor="Part"
                            className={`flex items-center gap-3 rounded-xl border px-4 py-3 cursor-pointer transition
                      ${paymentMode == 2
                                ? 'border-blue-500 bg-blue-50'
                                : 'border-gray-300 hover:border-blue-400'
                              }`}
                          >
                            <input
                              type="radio"
                              id="Part"
                              value="2"
                              name="paymentMode"
                              onChange={paymentModeHandle}
                              checked={paymentMode == 2}
                              className="h-4 w-4 text-blue-600 focus:ring-blue-500"
                            />
                            <span className="text-sm font-medium text-gray-700">
                              Online
                            </span>
                          </label>
                        </li>
                      </ul>
                    </div>

                    {/* Action Button */}
                    <div className="sm:col-span-2 flex justify-end pt-4">
                      <button
                        type="submit"
                        disabled={PaymentProcessloading}
                        className={`inline-flex items-center justify-center rounded-xl px-6 py-2.5 text-sm font-medium text-white shadow transition
                  ${PaymentProcessloading
                            ? 'bg-gray-400 cursor-not-allowed'
                            : 'bg-blue-600 hover:bg-blue-700'
                          }`}
                      >
                        {PaymentProcessloading ? 'Please wait...' : 'Proceed To Pay'}
                      </button>
                    </div>

                  </div>
                </form>
              </div>
            </div>
          </div>
        )}

        <div className="bg-white shadow-md rounded-lg overflow-hidden p-2">
          <div className="overflow-x-auto">
            <table className="min-w-full border  text-sm">
              <thead className="bg-gray-100 text-gray-700">
                <tr>
                  <th className="px-3 py-2 border text-left">No.</th>
                  <th className="px-3 py-2 border text-left" nowrap="true">
                    Trx Date
                  </th>
                  <th className="px-3 py-2 border text-left" nowrap="true">
                    Travel Date/Time
                  </th>
                  <th className="px-3 py-2 border text-left">Booking ID/PNR</th>
                  <th className="px-3 py-2 border text-left">Summary</th>

                  <th className="px-3 py-2 border text-left" nowrap="true">
                    {user.UserData.user.UserType != 6 && user.UserData.user.UserType != 7 && (
                      <>
                        My Cost<br />
                      </>
                    )}
                    Price Quote
                  </th>

                  <th className="px-3 py-2 border text-left" nowrap="true">
                    Passenger Name
                  </th>
                  <th className="px-3 py-2 border text-left" nowrap="true">
                    {" "}
                    Status/Last Update
                  </th>
                  <th className="px-3 py-2 border text-right">Action</th>
                </tr>
              </thead>
              <tbody>
                {bookingcalendarStatus === "loading" ? (
                  <>
                    <tr className="border-b">
                      <td className="px-3 py-2 border" colSpan={12}>
                        <ShimmerLoader />
                        <ShimmerLoader />
                        <ShimmerLoader />
                        <ShimmerLoader />
                        <ShimmerLoader />
                      </td>
                    </tr>
                  </>
                ) : (
                  <>
                    {BookingHistory.length > 0 ? (
                      BookingHistory.map((item, key) => (
                        <tr className="border-b" key={key}>
                          <td className="px-3 py-2 border">{key + 1}</td>
                          <td className="px-3 py-2 border" nowrap="true">
                            {format(parseISO(item.created_at), "dd MMM, yyyy")}
                            <br />
                            {Moment(item.created_at).format("h:mm A")}
                          </td>
                          <td className="px-3 py-2 border" nowrap="true">
                            {Moment(item.FromUTCTime).format("ddd Do MMM")}
                            <br />
                            {Moment(item.FromUTCTime).format("h:mm A")}
                          </td>
                          <td className="px-3 py-2 border">
                            <a
                              target="_blank"
                              style={{ color: "blue", textDecoration: "underline" }}
                              href={`/flight/booking-confirmation/${item.BookingID}`}
                            >
                              {item.BookingID}
                            </a>
                            <br />
                            Remark - {item.Errormessage}
                          </td>
                          <td nowrap="true" className="px-3 py-2 border">
                            {item.SoCode + "-" + item.DeCode}
                            <br />
                            {item.FlightNumber}
                            <br />
                            {item.AirlineName}
                          </td>
                          <td className="px-3 py-2 border" nowrap="true">
                            <CurFt
                              currency={item?.Currncy || "INR"}
                              price={
                                parseFloat(item.PubFare) +
                                parseFloat(item.BagPrice) +
                                parseFloat(item.MealPrice) +
                                parseFloat(item.SeatPrice) -
                                parseFloat(item.agent_markup)
                              }
                            />
                            <br />
                            {item?.partialpayment && (
                              <>
                                <span className="font-bold"> Pay {item?.partialpayment ? item?.payment_percentage + '%' : '100%'}</span>
                              </>
                            )}
                            <br />
                            {user.UserData.user.UserType != 6 && user.UserData.user.UserType != 7 && (
                              <>
                                <br />
                                <CurFt
                                  currency={item?.Currncy || "INR"}
                                  price={
                                    parseFloat(item.PubFare) +
                                    parseFloat(item.BagPrice) +
                                    parseFloat(item.MealPrice) +
                                    parseFloat(item.SeatPrice)
                                  }
                                />
                              </>
                            )}
                          </td>

                          <td className="px-3 py-2 border" nowrap="true">
                            {item.customerName} <br />
                            Total Pax:{item.TotalPax}<br />
                            {(item.BookingStatus === 32 || item.BookingStatus === 33) && (
                              <span className="text-red-600 animate-blink">Expiry {Moment(item?.timeLimit).format('DD MMM YYYY')} {Moment(item?.timeLimit).format("h:mm A")}</span>
                            )}
                          </td>
                          <td className="px-3 py-2 border" nowrap="true">
                            {(() => {
                              if (item.BookingStatus === 1 || item.BookingStatus === 33) {
                                return (
                                  <>
                                    <span style={{ color: "green" }}>{BOOKINGSTATUS[item.BookingStatus]}</span>
                                  </>
                                )
                              } else if (item.BookingStatus === 32) {
                                return (
                                  <>
                                    <span style={{ color: "orange" }}>{BOOKINGSTATUS[item.BookingStatus]}</span>
                                  </>
                                )
                              } else if (item.BookingStatus === 31) {
                                return (
                                  <>
                                    <span style={{ color: "red" }}>{BOOKINGSTATUS[item.BookingStatus]}</span>
                                  </>
                                )
                              } else {
                                return (
                                  <>
                                    <span style={{ color: "blue" }}>{BOOKINGSTATUS[item.BookingStatus]}</span>
                                  </>
                                )
                              }
                            })()}
                            <br />
                            {(() => {
                              if (item.PaymentStatus === 1) {
                                return (
                                  <>
                                    Payment : <span style={{ color: "green" }}>{PAYMENTSTATUS[item.PaymentStatus]}</span>
                                  </>
                                )
                              } else if (item.PaymentStatus === 2) {
                                return (
                                  <>
                                    Payment : <span className="text-orange-600">{PAYMENTSTATUS[item.PaymentStatus]}</span>
                                  </>
                                )
                              } else {
                                return (
                                  <>
                                    Payment : <span style={{ color: "red" }}>{PAYMENTSTATUS[item.PaymentStatus]}</span>
                                  </>
                                )
                              }
                            })()}
                            <br />
                            {Moment(item.updated_at).format("ddd Do MMM")} {Moment(item.updated_at).format("h:mm A")}


                          </td>
                          <td className="text-right px-3 py-2 border">
                            <div className="relative inline-block text-left">
                              <button
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setOpenRowId(openRowId === item.id ? null : item.id);
                                }}
                                className="inline-flex items-center gap-2 rounded-md border px-4 py-2 text-sm font-medium shadow-sm hover:bg-gray-50"
                              >
                                <Ellipsis className="h-4 w-4" />
                                {openRowId === item.id ? (
                                  <ChevronUp className="h-4 w-4" />
                                ) : (
                                  <ChevronDown className="h-4 w-4" />
                                )}
                              </button>

                              {openRowId === item.id && (
                                <div className="absolute right-0 z-50 mt-2 w-48 rounded-md bg-white shadow-lg border">
                                  <a
                                    target="_blank"
                                    className="block w-full px-4 py-2 text-left text-sm hover:bg-gray-100"
                                    href={`/flight/booking-confirmation/${item.BookingID}`}
                                  >
                                    View
                                  </a>
                                  {item.PaymentStatus === 1 && (
                                    <a
                                      target="_blank"
                                      className="block w-full px-4 py-2 text-left text-sm hover:bg-gray-100"
                                      href={`/flight/update-passenger/${item.BookingID}`}
                                    >
                                      Update Passenger
                                    </a>
                                  )}
                                  <button onClick={() => CheckQuoteHand(item)} className="block w-full px-4 py-2 text-left text-sm hover:bg-gray-100">
                                    Check Details
                                  </button>
                                  {item.BookingStatus === 33 && (item.PaymentStatus === 0 || item.PaymentStatus === 2) && (
                                    <button onClick={() => MakePayment(item)} className="block w-full px-4 py-2 text-left text-sm hover:bg-gray-100">
                                      Make Payment
                                    </button>
                                  )}

                                </div>
                              )}
                            </div>
                          </td>

                        </tr>
                      ))
                    ) : (
                      <>
                        <tr className="border-b">
                          <td colSpan={12} className="px-3 py-2 border">
                            No record found
                          </td>
                        </tr>
                      </>
                    )}
                  </>
                )}
              </tbody>
            </table>
            <CursorPagination
              nextCursor={nextCursor}
              prevCursor={prevCursor}
              onNext={handleNextPage}
              onPrev={handlePrevPage}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
            />
          </div>
        </div>

        <Dialog
          open={isSectorModalOpen}
          onClose={() => setIsModalSector(false)}
          className="fixed inset-0 z-50 mt-0 flex items-center justify-center bg-black bg-opacity-40"
        >
          <form onSubmit={handleSubmit} className="">
            <div className="bg-white w-full max-w-[1100px] max-h-[90vh] rounded-2xl shadow-lg flex flex-col">

              {/* ===== Header ===== */}
              <div className="flex items-center justify-between rounded-2xl px-6 py-4 border-b sticky top-0 bg-white z-10">
                <h2 className="text-lg font-semibold">Quote Details</h2>
                <button
                  type="button"
                  onClick={() => setIsModalSector(false)}
                  className="text-gray-500 hover:text-gray-700"
                >
                  <X size={20} />
                </button>
              </div>

              {/* ===== Body ===== */}
              <div className="flex-1 overflow-y-auto px-6 py-4 space-y-6">

                {loadingData ? (
                  <div className="flex items-center justify-center py-10">
                    <div className="w-12 h-12 border-4 border-blue-600 border-t-transparent rounded-full animate-spin" />
                  </div>
                ) : (
                  <>
                    {BookingData.map((items, keys) => (
                      <div key={'mainloop' + keys} className="space-y-3">

                        {/* Sector Title */}
                        <div className="font-semibold text-sm bg-gray-100 px-3 py-2 rounded-md">
                          {items.SoCity} to {items.DeCity} on {Moment(items.FromUTCTime).format('ddd Do MMM YYYY')}
                        </div>

                        {/* Table */}
                        <div className="overflow-x-auto">
                          <table className="min-w-full border border-gray-200 text-sm">
                            <thead className="bg-gray-50">
                              <tr className="text-left">
                                <th className="p-2">Pax Type</th>
                                <th className="p-2 text-end">Base Fare</th>
                                <th className="p-2 text-end">Taxes & Fee</th>
                                <th className="p-2 text-end">Total</th>
                              </tr>
                            </thead>

                            <tbody>
                              {items.FareLists.FareBreak.map((item, key) => (
                                <tr key={'FareBreak' + key} className="border-t">
                                  <td className="p-2">
                                    {item.PaxType} ({item.PassengerCount})
                                  </td>

                                  <td className="p-2 text-end">
                                    {item.BaseFare.toFixed(2)}
                                  </td>

                                  <td className="p-2 text-end">
                                    {(item.Tax + item.FixedMarkUp + item.GSTOnMarkUp).toFixed(2)}
                                  </td>

                                  <td className="p-2 text-end">{item.PublishedFare.toFixed(2)}</td>
                                </tr>
                              ))}

                              {(() => {
                                const {
                                  ToPublishedFare,
                                  Toagent_markup
                                } = items.FareLists.FareBreak.reduce(
                                  (totals, item) => {
                                    totals.ToPublishedFare += item.PublishedFare ?? 0;
                                    totals.ToGSTOnMarkUp += item.GSTOnMarkUp ?? 0;
                                    totals.ToFixedMarkUp += item.FixedMarkUp ?? 0;
                                    totals.Toagent_markup += item.agent_markup ?? 0;
                                    return totals;
                                  },
                                  {
                                    ToPublishedFare: 0,
                                    ToGSTOnMarkUp: 0,
                                    ToFixedMarkUp: 0,
                                    Toagent_markup: 0
                                  }
                                );

                                return (
                                  <>
                                    <tr className="border-t font-semibold bg-gray-50">
                                      <td colSpan={3}></td>

                                      <td className="p-2 text-end">
                                        <CurFt currency={Currency} price={ToPublishedFare} />
                                      </td>
                                    </tr>
                                    <tr className="border-t font-semibold ">
                                      <td colSpan={4}>
                                        <table className="min-w-full border border-gray-200 text-sm">
                                          <thead className="bg-blue-100">
                                            <tr className="text-left">
                                              <th colSpan={2} className="p-2">Time Limit</th>
                                            </tr>

                                          </thead>
                                          <tbody>
                                            <tr className="text-left">
                                              <td className="p-2">Request Expiry</td>
                                              <td className="p-2 font-normal text-red-600 animate-blink">{Moment(SelectedItem?.timeLimit).format('ddd Do MMM YYYY')} {Moment(SelectedItem?.timeLimit).format("h:mm A")}</td>
                                            </tr>
                                            <tr className="text-left">
                                              <td className="p-2">Immediate Payment</td>
                                              <td className="p-2 font-normal">{SelectedItem?.partialpayment ? SelectedItem?.payment_percentage + '%' : '100%'}</td>
                                            </tr>
                                            <tr className="text-left">
                                              <td className="p-2">Last responded on</td>
                                              <td className="p-2 font-normal">{Moment(SelectedItem?.updated_at).format("ddd Do MMM")} {Moment(SelectedItem?.updated_at).format("h:mm A")}</td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </td>
                                    </tr>
                                  </>
                                );
                              })()}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    ))}

                    {/* Remarks */}
                    <div className="space-y-1">
                      <p>Message : {SelectedItem?.Errormessage}</p>
                      <label className="text-sm font-medium">Remarks</label>
                      <textarea
                        name="remarks"
                        value={formData.remarks}
                        onChange={handleChange}
                        rows={3}
                        className="w-full border rounded-lg px-3 py-2"
                        placeholder="eg- Enter remarks"
                      />
                    </div>
                    <div className="text-red-600 text-center">Fares are available first come first  serve basis. The quoted fare may get invalid without intimation. <br /> Seats are not guaranteed until booked. Taxes are subject to change.</div>
                  </>
                )}
              </div>

              {/* ===== Footer ===== */}

              <div className="border-t px-6 py-4 flex justify-center bg-white rounded-2xl">
                <button
                  type="submit"
                  savetype='1'
                  disabled={loading === true}
                  className={`px-6 py-2 rounded-md text-white transition ${loading === true
                    ? "bg-gray-400 cursor-not-allowed"
                    : "bg-red-500 hover:bg-red-600"
                    }`}
                >
                  {loading === true ? "Please wait..." : "Reject"}
                </button>&nbsp;
                {(SelectedItem?.BookingStatus === 20 || SelectedItem?.BookingStatus === 32) && (
                  <button
                    type="submit"
                    savetype='2'
                    disabled={loading === true}
                    className={`px-6 py-2 rounded-md text-white transition ${loading === true
                      ? "bg-gray-400 cursor-not-allowed"
                      : "bg-green-500 hover:bg-green-600"
                      }`}
                  >
                    {loading === true ? "Please wait..." : "Accept"}
                  </button>
                )}
                &nbsp;
                {SelectedItem?.negotiationallow && SelectedItem?.BookingStatus !== 33 && (
                  <button
                    type="submit"
                    savetype='3'
                    disabled={loading === true}
                    className={`px-6 py-2 rounded-md text-white transition ${loading === true
                      ? "bg-gray-400 cursor-not-allowed"
                      : "bg-blue-500 hover:bg-blue-600"
                      }`}
                  >
                    {loading === true ? "Please wait..." : "Negotiate"}
                  </button>
                )}

              </div>
            </div>
          </form>
        </Dialog>

      </main>
    </div>
  );
}
